module.exports = __webpack_public_path__ + "img/robot1.9c2d5ea1.svg";